import { render, staticRenderFns } from "./SearchFilter.vue?vue&type=template&id=64dbf4a6&scoped=true"
import script from "./SearchFilter.vue?vue&type=script&lang=js"
export * from "./SearchFilter.vue?vue&type=script&lang=js"
import style0 from "./SearchFilter.vue?vue&type=style&index=0&id=64dbf4a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dbf4a6",
  null
  
)

export default component.exports